import { useMutation } from '@tanstack/react-query';
import { AI_API } from 'utils/globalApiServices';
import Organization from 'infrastructure/Organization';

const mutationFn = async ({ assignment_uuid, scenario_uuid, session_uuid, body = {} }) => {
  const org_id = Organization.getSelectedOrg()?.id;
  if (session_uuid) {
    const url = `/orgs/${org_id}/realplays/assignments/${assignment_uuid}/scenarios/${scenario_uuid}/sessions/${session_uuid}`;
    const { data } = await AI_API.put(url, body);
    return data;
  }
  return {};
};

const useUpdateRealPlaySessionStatusMutation = () => {
  return useMutation({
    mutationFn,
  });
};

export default useUpdateRealPlaySessionStatusMutation;
